<template>
	<div class="mini-shop-page">
		<div class="page-head">
			<div class="tab-bar">
				<button
					v-for="item in tabs"
					:key="item.name"
					type="button"
					class="tab-btn"
					:class="{ 'is-active': tab === item.name }"
					@click="switchTab(item.name)"
				>{{ item.label }}</button>
			</div>
			<el-form :inline="true" size="small" class="filter-form" @submit.native.prevent="onRefresh">
				<el-form-item>
					<el-button type="primary" :loading="loading" @click="onRefresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div class="table-wrap">
			<el-table :data="list" size="small" height="100%" v-loading="loading" class="shop-table">
				<el-table-column label="分销员" min-width="200">
					<template slot-scope="scope">
						<div class="buyer-cell">
							<div class="avatar">
								<img v-if="scope.row.avatar" :src="scope.row.avatar" alt="" width="32" height="32">
								<i v-else class="el-icon-user"></i>
							</div>
							<div class="buyer-meta">
								<div class="buyer-name">{{ scope.row.nickname || '未知' }}</div>
								<div class="sub">{{ scope.row.mobile || '-' }}</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="等级" width="120" align="center">
					<template slot-scope="scope">{{ scope.row.level_text || '-' }}</template>
				</el-table-column>
				<el-table-column width="110" align="center">
					<template slot="header">
						<span>团队人数</span>
						<el-tooltip content="落库值，升级扫描时校正，点开团队即为实时人数" placement="top">
							<i class="el-icon-info header-tip"></i>
						</el-tooltip>
					</template>
					<template slot-scope="scope">{{ scope.row.team_count != null ? scope.row.team_count : '-' }}</template>
				</el-table-column>
				<el-table-column label="累计销售额" width="120" align="center">
					<template slot-scope="scope">{{ scope.row.total_sales_yuan || '-' }}</template>
				</el-table-column>
				<el-table-column label="已结算佣金" width="120" align="center">
					<template slot-scope="scope">{{ scope.row.total_commission_yuan || '-' }}</template>
				</el-table-column>
				<el-table-column label="待结算佣金" width="120" align="center">
					<template slot-scope="scope">{{ scope.row.pending_commission_yuan || '-' }}</template>
				</el-table-column>
				<el-table-column label="待抵扣欠款" width="120" align="center">
					<template slot-scope="scope">
						<el-tooltip
							v-if="hasDebt(scope.row.debt_commission_yuan)"
							content="已结算订单退款后的待抵扣金额，下次结算自动扣除"
							placement="top"
						>
							<span class="debt-text">{{ scope.row.debt_commission_yuan }}</span>
						</el-tooltip>
						<span v-else>{{ scope.row.debt_commission_yuan || '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column label="状态" width="130" align="center">
					<template slot-scope="scope">
						<div class="status-cell">
							<el-switch
								v-model="scope.row.state"
								:active-value="1"
								:inactive-value="0"
								active-color="#ff4714"
								inactive-color="#dcdfe6"
								:disabled="adjustingUid === scope.row.uid"
								@change="onStateChange(scope.row)"
							/>
							<span class="status-label">{{ Number(scope.row.state) === 1 ? '启用' : '停用' }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="220" align="center" fixed="right">
					<template slot-scope="scope">
						<div class="op-cell">
							<span class="cell-link" @click="openLevel(scope.row)">调级</span>
							<span class="cell-link" @click="openCommission(scope.row)">佣金</span>
							<span class="cell-link" @click="openTeam(scope.row)">团队</span>
							<span class="cell-link" @click="openIncome(scope.row)">构成</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div class="pager">
			<el-pagination
				background
				layout="total, sizes, prev, pager, next"
				:total="total"
				:current-page="page"
				:page-size="limit"
				:page-sizes="pageSizes"
				@current-change="onPageChange"
				@size-change="onSizeChange"
			/>
		</div>

		<el-dialog title="调整等级" :visible.sync="levelVisible" width="420px" append-to-body>
			<div v-if="currentRow" class="level-dialog">
				<p class="level-current">当前：{{ currentRow.nickname || '未知' }}（{{ currentRow.level_text || '-' }}）</p>
				<el-radio-group v-model="levelValue">
					<el-radio :label="1">二级分销员</el-radio>
					<el-radio :label="2">一级分销员</el-radio>
				</el-radio-group>
				<p class="field-tip">自动升级只升不降。手动把一级调回二级后，次日达标仍可能再升。</p>
			</div>
			<span slot="footer">
				<el-button size="small" @click="levelVisible = false">取消</el-button>
				<el-button type="primary" size="small" :loading="adjustingUid === (currentRow && currentRow.uid)" @click="submitLevel">确定</el-button>
			</span>
		</el-dialog>

		<el-dialog
			:title="commissionTitle"
			:visible.sync="commissionVisible"
			width="960px"
			append-to-body
			@close="onCommissionClose"
		>
			<div v-if="distributor" class="summary-bar">
				<span>等级 {{ distributor.level_text || '-' }}</span>
				<span>团队 {{ distributor.team_count != null ? distributor.team_count : '-' }}</span>
				<span>销售额 {{ distributor.total_sales_yuan || '-' }}</span>
				<span :class="{ 'debt-text': hasDebt(distributor.debt_commission_yuan) }">欠款 {{ distributor.debt_commission_yuan || '-' }}</span>
				<span>待结算 {{ summary.pending_yuan || '-' }}</span>
				<span>已结算 {{ summary.settled_yuan || '-' }}</span>
				<span>已退回 {{ summary.refunded_yuan || '-' }}</span>
			</div>
			<el-form :inline="true" size="small" class="filter-form" @submit.native.prevent="onCommissionSearch">
				<el-form-item>
					<el-date-picker
						v-model="commissionMonth"
						type="month"
						value-format="yyyy-MM"
						placeholder="月份"
						clearable
					/>
				</el-form-item>
				<el-form-item>
					<el-select v-model="commissionStatus" placeholder="全部状态" clearable>
						<el-option label="待结算" :value="0" />
						<el-option label="已结算" :value="1" />
						<el-option label="已退回" :value="2" />
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onCommissionSearch">查询</el-button>
				</el-form-item>
			</el-form>
			<el-table :data="commissionList" size="small" v-loading="commissionLoading" max-height="420">
				<el-table-column label="月份" width="100" align="center">
					<template slot-scope="scope">{{ scope.row.month || '-' }}</template>
				</el-table-column>
				<el-table-column label="佣金" width="100" align="center">
					<template slot-scope="scope">{{ scope.row.commission_yuan || '-' }}</template>
				</el-table-column>
				<el-table-column label="退回佣金" width="100" align="center">
					<template slot-scope="scope">{{ scope.row.refund_commission_yuan || '-' }}</template>
				</el-table-column>
				<el-table-column label="零售" width="100" align="center">
					<template slot-scope="scope">{{ scope.row.retail_fee_yuan || '-' }}</template>
				</el-table-column>
				<el-table-column label="利润" width="100" align="center">
					<template slot-scope="scope">{{ scope.row.profit_fee_yuan || '-' }}</template>
				</el-table-column>
				<el-table-column label="状态" width="90" align="center">
					<template slot-scope="scope">{{ scope.row.status_text || '-' }}</template>
				</el-table-column>
				<el-table-column label="产生时间" min-width="160" align="center">
					<template slot-scope="scope">{{ scope.row.create_time_str || '-' }}</template>
				</el-table-column>
				<el-table-column label="结算时间" min-width="160" align="center">
					<template slot-scope="scope">{{ scope.row.settle_time_str || '-' }}</template>
				</el-table-column>
				<el-table-column label="操作" width="80" align="center" fixed="right">
					<template slot-scope="scope">
						<span v-if="hasOrderId(scope.row)" class="cell-link" @click="openOrderChain(scope.row)">链路</span>
						<span v-else class="sub">-</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="pager">
				<el-pagination
					background
					layout="total, sizes, prev, pager, next"
					:total="commissionTotal"
					:current-page="commissionPage"
					:page-size="commissionLimit"
					:page-sizes="pageSizes"
					@current-change="onCommissionPageChange"
					@size-change="onCommissionSizeChange"
				/>
			</div>
		</el-dialog>

		<el-dialog
			:title="teamTitle"
			:visible.sync="teamVisible"
			width="960px"
			append-to-body
			@close="onTeamClose"
		>
			<div v-if="teamStack.length" class="crumb">
				<span
					v-for="(item, idx) in teamStack"
					:key="item.uid + '-' + idx"
				>
					<span v-if="idx" class="crumb-sep">/</span>
					<span
						:class="{ 'cell-link': idx < teamStack.length - 1 }"
						@click="goTeamLevel(idx)"
					>{{ item.nickname || '未知' }}</span>
				</span>
			</div>
			<div v-if="teamHeader" class="person-head">
				<div class="avatar avatar-lg">
					<img v-if="teamHeader.avatar" :src="teamHeader.avatar" alt="" width="36" height="36">
					<i v-else class="el-icon-user"></i>
				</div>
				<div>
					<div>{{ teamHeader.nickname || '未知' }} · {{ teamHeader.level_text || '-' }} · {{ teamHeader.state_text || '-' }}</div>
					<div class="sub">{{ teamHeader.mobile || '-' }} · 实时直推 {{ teamHeader.team_count != null ? teamHeader.team_count : '-' }} 人</div>
				</div>
			</div>
			<div class="summary-bar">
				<span>直推 {{ teamSummary.total != null ? teamSummary.total : '-' }}</span>
				<span>已开通 {{ teamSummary.opened != null ? teamSummary.opened : '-' }}</span>
				<span>一级 {{ teamSummary.first_level_count != null ? teamSummary.first_level_count : '-' }}</span>
				<span>二级 {{ teamSummary.second_level_count != null ? teamSummary.second_level_count : '-' }}</span>
				<span>停用 {{ teamSummary.disabled != null ? teamSummary.disabled : '-' }}</span>
				<span>未开通 {{ teamSummary.not_opened != null ? teamSummary.not_opened : '-' }}</span>
			</div>
			<el-table :data="teamList" size="small" v-loading="teamLoading" max-height="380">
				<el-table-column label="成员" min-width="180">
					<template slot-scope="scope">
						<div class="buyer-cell">
							<div class="avatar">
								<img v-if="scope.row.avatar" :src="scope.row.avatar" alt="" width="32" height="32">
								<i v-else class="el-icon-user"></i>
							</div>
							<div class="buyer-meta">
								<div class="buyer-name">{{ scope.row.nickname || '未知' }}</div>
								<div class="sub">{{ scope.row.mobile || '-' }}</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="状态" width="90" align="center">
					<template slot-scope="scope">{{ scope.row.dist_state_text || '未开通' }}</template>
				</el-table-column>
				<el-table-column label="等级" width="110" align="center">
					<template slot-scope="scope">{{ scope.row.level_text || '-' }}</template>
				</el-table-column>
				<el-table-column label="下级" width="80" align="center">
					<template slot-scope="scope">{{ scope.row.team_count != null ? scope.row.team_count : '-' }}</template>
				</el-table-column>
				<el-table-column label="销售额" width="100" align="center">
					<template slot-scope="scope">{{ scope.row.total_sales_yuan || '-' }}</template>
				</el-table-column>
				<el-table-column label="已结算佣金" width="110" align="center">
					<template slot-scope="scope">{{ scope.row.total_commission_yuan || '-' }}</template>
				</el-table-column>
				<el-table-column label="邀请时间" min-width="160" align="center">
					<template slot-scope="scope">{{ scope.row.invite_time_str || '-' }}</template>
				</el-table-column>
				<el-table-column label="操作" width="120" align="center" fixed="right">
					<template slot-scope="scope">
						<span v-if="canDrill(scope.row)" class="cell-link" @click="drillTeam(scope.row)">下钻</span>
						<span class="cell-link" :class="{ 'cell-link-gap': canDrill(scope.row) }" @click="openInviteChain(scope.row)">邀请链</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="pager">
				<el-pagination
					background
					layout="total, sizes, prev, pager, next"
					:total="teamTotal"
					:current-page="teamPage"
					:page-size="teamLimit"
					:page-sizes="pageSizes"
					@current-change="onTeamPageChange"
					@size-change="onTeamSizeChange"
				/>
			</div>
		</el-dialog>

		<el-dialog
			:title="incomeTitle"
			:visible.sync="incomeVisible"
			width="720px"
			append-to-body
			@close="onIncomeClose"
		>
			<div v-if="incomeHeader" class="person-head">
				<div class="avatar avatar-lg">
					<img v-if="incomeHeader.avatar" :src="incomeHeader.avatar" alt="" width="36" height="36">
					<i v-else class="el-icon-user"></i>
				</div>
				<div>
					<div>{{ incomeHeader.nickname || '未知' }} · {{ incomeHeader.level_text || '-' }} · {{ incomeHeader.state_text || '-' }}</div>
				</div>
			</div>
			<el-form :inline="true" size="small" class="filter-form" @submit.native.prevent="onIncomeSearch">
				<el-form-item>
					<el-date-picker
						v-model="incomeMonth"
						type="month"
						value-format="yyyy-MM"
						placeholder="全部月份"
						clearable
					/>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" :loading="incomeLoading" @click="onIncomeSearch">查询</el-button>
				</el-form-item>
			</el-form>
			<div v-loading="incomeLoading" class="income-cards">
				<div class="income-card">
					<div class="income-label">自购</div>
					<div class="income-num">{{ (income.self && income.self.commission_yuan) || '0.00' }}</div>
					<div class="sub">{{ bucketMeta(income.self) }}</div>
				</div>
				<div class="income-card">
					<div class="income-label">团队</div>
					<div class="income-num">{{ (income.team && income.team.commission_yuan) || '0.00' }}</div>
					<div class="sub">{{ bucketMeta(income.team) }}</div>
				</div>
			</div>
			<div v-if="unknownCount > 0" class="unknown-block">
				<span class="cell-link" @click="incomeUnknownOpen = !incomeUnknownOpen">
					{{ incomeUnknownOpen ? '收起未知' : '查看未知' }}（{{ unknownCount }} 笔）
				</span>
				<div v-if="incomeUnknownOpen" class="income-card is-unknown">
					<div class="income-label">未知</div>
					<div class="income-num">{{ (income.unknown && income.unknown.commission_yuan) || '0.00' }}</div>
					<div class="sub">{{ bucketMeta(income.unknown) }}</div>
				</div>
			</div>
		</el-dialog>

		<el-dialog
			:title="chainTitle"
			:visible.sync="chainVisible"
			width="760px"
			append-to-body
			@close="onChainClose"
		>
			<div v-loading="chainLoading">
				<div v-if="chainMode === 'order' && chainConsumer" class="person-head">
					<div class="avatar avatar-lg">
						<img v-if="chainConsumer.avatar" :src="chainConsumer.avatar" alt="" width="36" height="36">
						<i v-else class="el-icon-user"></i>
					</div>
					<div>
						<div>消费者 {{ chainConsumer.nickname || '未知' }}</div>
						<div class="sub">订单 {{ chainOrderId || '-' }}</div>
					</div>
				</div>
				<div class="section-title">邀请链</div>
				<el-table :data="chainList" size="small" max-height="280">
					<el-table-column label="节点" min-width="180">
						<template slot-scope="scope">
							<div class="buyer-cell">
								<div class="avatar">
									<img v-if="scope.row.avatar" :src="scope.row.avatar" alt="" width="32" height="32">
									<i v-else class="el-icon-user"></i>
								</div>
								<div class="buyer-meta">
									<div class="buyer-name">{{ scope.row.nickname || '未知' }}</div>
									<div class="sub">
										{{ scope.row.dist_state_text || '未开通' }}
										<span v-if="Number(scope.row.is_delete) === 1"> · 已删除</span>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="分销等级" width="120" align="center">
						<template slot-scope="scope">{{ scope.row.level_text || '-' }}</template>
					</el-table-column>
					<el-table-column v-if="chainMode === 'order'" label="本单角色" width="120" align="center">
						<template slot-scope="scope">{{ recipientText(scope.row.recipient_level) }}</template>
					</el-table-column>
				</el-table>
				<template v-if="chainMode === 'order'">
					<div class="section-title">收款落点</div>
					<el-table :data="chainRecipients" size="small" max-height="220">
						<el-table-column label="收款人" min-width="160">
							<template slot-scope="scope">
								<div class="buyer-cell">
									<div class="avatar">
										<img v-if="scope.row.avatar" :src="scope.row.avatar" alt="" width="32" height="32">
										<i v-else class="el-icon-user"></i>
									</div>
									<div class="buyer-name">{{ scope.row.nickname || '未知' }}</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="佣金角色" width="110" align="center">
							<template slot-scope="scope">{{ scope.row.level_text || '-' }}</template>
						</el-table-column>
						<el-table-column label="金额" width="100" align="center">
							<template slot-scope="scope">{{ scope.row.commission_yuan || '-' }}</template>
						</el-table-column>
						<el-table-column label="状态" width="90" align="center">
							<template slot-scope="scope">{{ scope.row.status_text || '-' }}</template>
						</el-table-column>
					</el-table>
				</template>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { MINI_CONFIG_API, MINI_SHOP_PAGE_SIZES, canUseMiniprogram, getApiErrorMessage } from '@/constants/retailPlatform'

	export default {
		name: 'MiniprogramDistMembers',
		inject: ['appdata'],
		data() {
			return {
				tabs: [
					{ name: 'all', label: '全部' },
					{ name: '2', label: '一级' },
					{ name: '1', label: '二级' },
				],
				pageSizes: MINI_SHOP_PAGE_SIZES,
				tab: 'all',
				page: 1,
				limit: 20,
				total: 0,
				list: [],
				loading: false,
				adjustingUid: 0,
				levelVisible: false,
				levelValue: 1,
				currentRow: null,
				commissionVisible: false,
				commissionLoading: false,
				commissionList: [],
				commissionTotal: 0,
				commissionPage: 1,
				commissionLimit: 20,
				commissionMonth: '',
				commissionStatus: null,
				summary: {},
				distributor: null,
				teamVisible: false,
				teamLoading: false,
				teamStack: [],
				teamHeader: null,
				teamSummary: {},
				teamList: [],
				teamTotal: 0,
				teamPage: 1,
				teamLimit: 20,
				incomeVisible: false,
				incomeLoading: false,
				incomeRow: null,
				incomeHeader: null,
				incomeMonth: '',
				incomeUnknownOpen: false,
				income: {},
				chainVisible: false,
				chainLoading: false,
				chainMode: '',
				chainOrderId: 0,
				chainConsumer: null,
				chainList: [],
				chainRecipients: [],
			}
		},
		computed: {
			commissionTitle() {
				if (!this.currentRow) {
					return '佣金明细'
				}
				return '佣金明细 · ' + (this.currentRow.nickname || '未知')
			},
			teamTitle() {
				const last = this.teamStack[this.teamStack.length - 1]
				if (!last) {
					return '团队'
				}
				return '团队 · ' + (last.nickname || '未知')
			},
			incomeTitle() {
				if (!this.incomeRow) {
					return '收入构成'
				}
				return '收入构成 · ' + (this.incomeRow.nickname || '未知')
			},
			unknownCount() {
				return Number((this.income.unknown && this.income.unknown.count) || 0)
			},
			chainTitle() {
				if (this.chainMode === 'order') {
					return '订单链路'
				}
				if (this.chainMode === 'user') {
					return '邀请链'
				}
				return '链路追溯'
			},
		},
		mounted() {
			this.loadList()
		},
		methods: {
			hasDebt(val) {
				const num = Number(val)
				return !isNaN(num) && num > 0
			},
			hasOrderId(row) {
				return !!(row && Number(row.order_id) > 0)
			},
			canDrill(row) {
				return !!(row && String(row.dist_state_text || '').trim())
			},
			recipientText(level) {
				const num = Number(level)
				if (num === 1) {
					return '一级佣金'
				}
				if (num === 2) {
					return '二级佣金'
				}
				return '非收款'
			},
			bucketMeta(bucket) {
				const item = bucket || {}
				return (item.count || 0) + ' 笔 · 待结算 ' + (item.pending_yuan || '0.00') + ' · 已结算 ' + (item.settled_yuan || '0.00') + ' · 已退回 ' + (item.refunded_yuan || '0.00')
			},
			guardPermission() {
				if (!canUseMiniprogram(this.appdata && this.appdata.myinfo)) {
					this.$message.warning('未开通小程序功能，请联系管理员')
					return false
				}
				return true
			},
			switchTab(name) {
				if (this.tab === name) {
					return
				}
				this.tab = name
				this.page = 1
				this.loadList()
			},
			onRefresh() {
				this.page = 1
				this.loadList()
			},
			onPageChange(page) {
				this.page = page
				this.loadList()
			},
			onSizeChange(limit) {
				this.limit = limit
				this.page = 1
				this.loadList()
			},
			loadList() {
				const payload = {
					page: this.page,
					limit: this.limit,
				}
				if (this.tab !== 'all') {
					payload.level = Number(this.tab)
				}
				this.loading = true
				this.$axios.post(MINI_CONFIG_API.distMemberList, payload).then((res) => {
					if (!res.data || res.data.code != 0) {
						this.list = []
						this.total = 0
						this.$message.error(getApiErrorMessage(res, '获取分销员失败'))
						return
					}
					const data = res.data.data || {}
					this.list = (data.list || []).map((row) => {
						const item = Object.assign({}, row)
						item.state = Number(item.state) === 1 ? 1 : 0
						item.level = Number(item.level) === 2 ? 2 : 1
						return item
					})
					this.total = Number(data.total) || 0
				}).catch((err) => {
					console.log(err)
					this.list = []
					this.total = 0
					this.$message.error('获取分销员失败')
				}).finally(() => {
					this.loading = false
				})
			},
			onStateChange(row) {
				if (!row || !this.guardPermission()) {
					if (row) {
						row.state = Number(row.state) === 1 ? 0 : 1
					}
					return
				}
				const nextState = Number(row.state) === 1 ? 1 : 0
				const action = nextState === 1 ? 'enable' : 'disable'
				this.adjustingUid = row.uid
				this.$axios.post(MINI_CONFIG_API.distMemberAdjust, {
					distributor_uid: row.uid,
					action: action,
				}).then((res) => {
					if (!res.data || res.data.code != 0) {
						row.state = nextState === 1 ? 0 : 1
						this.$message.error(getApiErrorMessage(res, '调整失败'))
						return
					}
					this.$message.success(nextState === 1 ? '已启用' : '已停用')
				}).catch((err) => {
					console.log(err)
					row.state = nextState === 1 ? 0 : 1
					this.$message.error('调整失败')
				}).finally(() => {
					this.adjustingUid = 0
				})
			},
			openLevel(row) {
				if (!row) {
					return
				}
				this.currentRow = row
				this.levelValue = Number(row.level) === 2 ? 2 : 1
				this.levelVisible = true
			},
			submitLevel() {
				if (!this.currentRow || !this.guardPermission()) {
					return
				}
				const level = Number(this.levelValue) === 2 ? 2 : 1
				if (level === Number(this.currentRow.level)) {
					this.levelVisible = false
					return
				}
				this.adjustingUid = this.currentRow.uid
				this.$axios.post(MINI_CONFIG_API.distMemberAdjust, {
					distributor_uid: this.currentRow.uid,
					level: level,
				}).then((res) => {
					if (!res.data || res.data.code != 0) {
						this.$message.error(getApiErrorMessage(res, '调整失败'))
						return
					}
					this.$message.success('调整成功')
					this.levelVisible = false
					this.loadList()
				}).catch((err) => {
					console.log(err)
					this.$message.error('调整失败')
				}).finally(() => {
					this.adjustingUid = 0
				})
			},
			openCommission(row) {
				if (!row) {
					return
				}
				this.currentRow = row
				this.commissionMonth = ''
				this.commissionStatus = null
				this.commissionPage = 1
				this.commissionVisible = true
				this.loadCommission()
			},
			onCommissionClose() {
				this.commissionList = []
				this.summary = {}
				this.distributor = null
			},
			onCommissionSearch() {
				this.commissionPage = 1
				this.loadCommission()
			},
			onCommissionPageChange(page) {
				this.commissionPage = page
				this.loadCommission()
			},
			onCommissionSizeChange(limit) {
				this.commissionLimit = limit
				this.commissionPage = 1
				this.loadCommission()
			},
			loadCommission() {
				if (!this.currentRow) {
					return
				}
				const payload = {
					distributor_uid: this.currentRow.uid,
					page: this.commissionPage,
					limit: this.commissionLimit,
				}
				if (this.commissionMonth) {
					payload.month = this.commissionMonth
				}
				if (this.commissionStatus !== null && this.commissionStatus !== '') {
					payload.status = this.commissionStatus
				}
				this.commissionLoading = true
				this.$axios.post(MINI_CONFIG_API.distMemberCommission, payload).then((res) => {
					if (!res.data || res.data.code != 0) {
						this.commissionList = []
						this.commissionTotal = 0
						this.summary = {}
						this.distributor = null
						this.$message.error(getApiErrorMessage(res, '获取佣金明细失败'))
						return
					}
					const data = res.data.data || {}
					this.commissionList = data.list || []
					this.commissionTotal = Number(data.total) || 0
					this.summary = data.summary || {}
					this.distributor = data.distributor || null
				}).catch((err) => {
					console.log(err)
					this.commissionList = []
					this.commissionTotal = 0
					this.summary = {}
					this.distributor = null
					this.$message.error('获取佣金明细失败')
				}).finally(() => {
					this.commissionLoading = false
				})
			},
			openTeam(row) {
				if (!row || !row.uid) {
					return
				}
				this.teamStack = [{ uid: row.uid, nickname: row.nickname || '未知' }]
				this.teamPage = 1
				this.teamVisible = true
				this.loadTeam()
			},
			onTeamClose() {
				this.teamStack = []
				this.teamHeader = null
				this.teamSummary = {}
				this.teamList = []
				this.teamTotal = 0
			},
			drillTeam(row) {
				if (!this.canDrill(row) || !row.uid) {
					return
				}
				this.teamStack.push({ uid: row.uid, nickname: row.nickname || '未知' })
				this.teamPage = 1
				this.loadTeam()
			},
			goTeamLevel(idx) {
				if (idx < 0 || idx >= this.teamStack.length - 1) {
					return
				}
				this.teamStack = this.teamStack.slice(0, idx + 1)
				this.teamPage = 1
				this.loadTeam()
			},
			onTeamPageChange(page) {
				this.teamPage = page
				this.loadTeam()
			},
			onTeamSizeChange(limit) {
				this.teamLimit = limit
				this.teamPage = 1
				this.loadTeam()
			},
			loadTeam() {
				const last = this.teamStack[this.teamStack.length - 1]
				if (!last) {
					return
				}
				this.teamLoading = true
				this.$axios.post(MINI_CONFIG_API.distMemberTeam, {
					distributor_uid: last.uid,
					page: this.teamPage,
					limit: this.teamLimit,
				}).then((res) => {
					if (!res.data || res.data.code != 0) {
						this.teamHeader = null
						this.teamSummary = {}
						this.teamList = []
						this.teamTotal = 0
						this.$message.error(getApiErrorMessage(res, '获取团队失败'))
						return
					}
					const data = res.data.data || {}
					this.teamHeader = data.distributor || null
					this.teamSummary = data.summary || {}
					this.teamList = data.list || []
					this.teamTotal = Number(data.total) || 0
				}).catch((err) => {
					console.log(err)
					this.teamHeader = null
					this.teamSummary = {}
					this.teamList = []
					this.teamTotal = 0
					this.$message.error('获取团队失败')
				}).finally(() => {
					this.teamLoading = false
				})
			},
			openIncome(row) {
				if (!row || !row.uid) {
					return
				}
				this.incomeRow = row
				this.incomeMonth = ''
				this.incomeUnknownOpen = false
				this.incomeVisible = true
				this.loadIncome()
			},
			onIncomeClose() {
				this.incomeRow = null
				this.incomeHeader = null
				this.income = {}
				this.incomeUnknownOpen = false
			},
			onIncomeSearch() {
				this.loadIncome()
			},
			loadIncome() {
				if (!this.incomeRow) {
					return
				}
				const payload = {
					distributor_uid: this.incomeRow.uid,
				}
				if (this.incomeMonth) {
					payload.month = this.incomeMonth
				}
				this.incomeLoading = true
				this.$axios.post(MINI_CONFIG_API.distMemberIncome, payload).then((res) => {
					if (!res.data || res.data.code != 0) {
						this.incomeHeader = null
						this.income = {}
						this.$message.error(getApiErrorMessage(res, '获取收入构成失败'))
						return
					}
					const data = res.data.data || {}
					this.incomeHeader = data.distributor || null
					this.income = {
						self: data.self || {},
						team: data.team || {},
						unknown: data.unknown || {},
					}
				}).catch((err) => {
					console.log(err)
					this.incomeHeader = null
					this.income = {}
					this.$message.error('获取收入构成失败')
				}).finally(() => {
					this.incomeLoading = false
				})
			},
			openOrderChain(row) {
				if (!this.hasOrderId(row)) {
					return
				}
				this.loadChain({ order_id: Number(row.order_id) })
			},
			openInviteChain(row) {
				if (!row || !row.uid) {
					return
				}
				this.loadChain({ uid: row.uid })
			},
			onChainClose() {
				this.chainMode = ''
				this.chainOrderId = 0
				this.chainConsumer = null
				this.chainList = []
				this.chainRecipients = []
			},
			loadChain(payload) {
				this.chainVisible = true
				this.chainLoading = true
				this.chainMode = ''
				this.chainConsumer = null
				this.chainList = []
				this.chainRecipients = []
				this.$axios.post(MINI_CONFIG_API.distMemberChain, payload).then((res) => {
					if (!res.data || res.data.code != 0) {
						this.$message.error(getApiErrorMessage(res, '获取链路失败'))
						return
					}
					const data = res.data.data || {}
					this.chainMode = data.mode || ''
					this.chainOrderId = data.order_id || 0
					this.chainConsumer = data.consumer || null
					this.chainList = data.chain || []
					this.chainRecipients = data.recipients || []
				}).catch((err) => {
					console.log(err)
					this.$message.error('获取链路失败')
				}).finally(() => {
					this.chainLoading = false
				})
			},
		},
	}
</script>

<style scoped lang="less">
	.mini-shop-page {
		height: 100%;
		display: flex;
		flex-direction: column;
		background: #fff;
		padding: 12px 16px 8px;
		box-sizing: border-box;
		overflow: hidden;
	}

	.page-head {
		flex: none;
	}

	.tab-bar {
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ebeef5;
		margin-bottom: 12px;
	}

	.tab-btn {
		position: relative;
		display: inline-flex;
		align-items: center;
		height: 40px;
		padding: 0 16px;
		border: 0;
		background: transparent;
		color: #606266;
		font-size: 14px;
		line-height: 1;
		cursor: pointer;
		outline: none;

		&.is-active {
			color: #ff4714;
			font-weight: 500;

			&::after {
				content: '';
				position: absolute;
				left: 16px;
				right: 16px;
				bottom: 0;
				height: 2px;
				background: #ff4714;
			}
		}
	}

	.filter-form {
		display: flex;
		align-items: center;
		margin-bottom: 12px;

		/deep/ .el-form-item {
			margin: 0 8px 0 0;
		}
	}

	.table-wrap {
		flex: 1;
		min-height: 0;
	}

	.shop-table {
		width: 100%;
	}

	.buyer-cell {
		display: flex;
		align-items: center;
		min-width: 0;
	}

	.avatar {
		width: 32px;
		height: 32px;
		flex: none;
		margin-right: 8px;
		border-radius: 50%;
		background: #f5f6f8;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 32px;
			height: 32px;
			object-fit: cover;
			display: block;
		}

		i {
			color: #c0c4cc;
		}
	}

	.avatar-lg {
		width: 36px;
		height: 36px;

		img {
			width: 36px;
			height: 36px;
		}
	}

	.buyer-meta {
		min-width: 0;
	}

	.buyer-name {
		color: #303133;
		line-height: 1.4;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.sub {
		margin-top: 2px;
		font-size: 12px;
		color: #909399;
	}

	.header-tip {
		margin-left: 4px;
		color: #c0c4cc;
		cursor: pointer;
	}

	.debt-text {
		color: #f56c6c;
		font-weight: 600;
		cursor: default;
	}

	.status-cell {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.status-label {
		margin-left: 6px;
		font-size: 12px;
		color: #606266;
	}

	.op-cell {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 6px 10px;
	}

	.cell-link {
		color: #ff4714;
		cursor: pointer;
		font-size: 13px;
	}

	.cell-link-gap {
		margin-left: 8px;
	}

	.pager {
		flex: none;
		padding: 10px 0 4px;
		text-align: right;
	}

	.level-dialog {
		line-height: 1.6;
	}

	.level-current {
		margin: 0 0 12px;
		color: #303133;
	}

	.field-tip {
		margin: 12px 0 0;
		font-size: 12px;
		line-height: 1.4;
		color: #909399;
	}

	.summary-bar {
		display: flex;
		flex-wrap: wrap;
		gap: 8px 16px;
		margin-bottom: 12px;
		font-size: 13px;
		color: #606266;
	}

	.crumb {
		margin-bottom: 12px;
		font-size: 13px;
		color: #606266;
	}

	.crumb-sep {
		margin: 0 6px;
		color: #c0c4cc;
	}

	.person-head {
		display: flex;
		align-items: center;
		margin-bottom: 12px;
		font-size: 14px;
		color: #303133;
	}

	.section-title {
		margin: 12px 0 8px;
		font-size: 13px;
		font-weight: 600;
		color: #303133;
	}

	.income-cards {
		display: flex;
		gap: 12px;
	}

	.income-card {
		flex: 1;
		padding: 12px 14px;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		background: #fafafa;
	}

	.income-label {
		font-size: 13px;
		color: #909399;
	}

	.income-num {
		margin: 6px 0 4px;
		font-size: 22px;
		font-weight: 600;
		color: #303133;
	}

	.unknown-block {
		margin-top: 12px;
	}

	.is-unknown {
		margin-top: 8px;
	}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/miniprogram/distMembers.vue